import React from "react";
import { ExpendableLink } from "./expendable-link";
import { DashboardIcon } from "../../components/icons";
import {
  Blocks,
  Cctv,
  Crosshair,
  LayoutDashboard,
  Package,
  RefreshCcw,
  ScanSearch,
  SendIcon,
  User,
  BookmarkCheck,
  Plus,
  GitCompare,
  DollarSign,
  Heart,
} from "lucide-react";

export const AdminMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={18} />}
      />

      <ExpendableLink
        title="Cibles"
        url="/sites"
        icon={<Crosshair size={18} />}
      />

      <ExpendableLink
        title="Produits"
        url="/products"
        icon={<Package size={18} />}
        submenus={[
          {
            title: "Prix uniquement",
            url: "/products-price-only",
            icon: <DollarSign size={16} />,
          },
        ]}
      />

      <ExpendableLink
        title="Références"
        url="/references"
        icon={<BookmarkCheck size={18} />}
        submenus={[
          {
            title: "Nouvelle référence",
            url: "/references/create",
            icon: <Plus size={16} />,
          },
        ]}
      />

      <ExpendableLink
        title="Scans"
        url="/scans"
        icon={<ScanSearch size={18} />}
      />

      <ExpendableLink
        title="Comparaison"
        url="/compare"
        icon={<GitCompare size={18} />}
      />

      <ExpendableLink
        title="Favoris"
        url="/favorites"
        icon={<Heart size={18} />}
      />

      <ExpendableLink
        title="Utilisateurs"
        url="/users"
        icon={<User size={18} />}
      />
      <ExpendableLink
        icon={<Blocks size={18} />}
        title="Categories"
        url="/categories"
      />

      <ExpendableLink
        icon={<Cctv size={18} />}
        title="Sentinelles"
        url="/sentinels"
      />
      <ExpendableLink
        icon={<RefreshCcw size={18} />}
        title="Tournées"
        url="/rounds"
      />
    </>
  );
};
